import React, { useState, useEffect,useContext } from 'react';
import axios from 'axios';
import { useLocation  } from 'react-router-dom';
import $ from 'jquery';
import { MyContext } from './MyContextProvider'; // Import your context
import { useParams,useNavigate  } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import './PREAUCT_Title_Lien_Precheck_S.css';

const PREAUCT_Title_Lien_Precheck_S = (props) => {
  const { i18n } = useTranslation();
  const { t } = useTranslation();
  var location = useLocation();
  const { App_Data, setApp_Data } = useContext(MyContext); // Access the context
  const urlParams = new URLSearchParams(window.location.search);
  //setReturn_Path(urlParams.get('Return'));
  const navigate = useNavigate();
  let selectedData ="";
  
  const inputFontStyle = {
    fontFamily: 'sans-serif',
    fontSize: '16px',
    fontWeight: 'normal',
    fontStyle: 'normal',
    color: '#000'
  };



  

  useEffect(() => {
    document.title = "SRWAE | "+t('Pre-Auction Title and Lien Precheck');  

 const handleReturn = async () => {
    const collectClientInfo = () => {
      return {
        userAgent: navigator.userAgent,
        language: navigator.language,
        platform: navigator.platform,
        screenResolution: `${screen.width}x${screen.height}`,
        colorDepth: screen.colorDepth,
        timezoneOffset: new Date().getTimezoneOffset(),
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        cookieEnabled: navigator.cookieEnabled,
        javaEnabled: navigator.javaEnabled(),
        online: navigator.onLine,
        referrer: document.referrer,
        locationHref: window.location.href,
        screenOrientation: screen.orientation?.type || 'unknown'
      };
    };

    const clientInfo = collectClientInfo();

    try {
      const response = await fetch('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/PREAUCT_TITLE_LIEN_PRECHECK/Select', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ data: App_Data.Data, clientInfo: clientInfo, stamp: Date.now() })
      });

      if (response.ok) {
        navigate('/PREAUCT_Title_Lien_Precheck', { replace: true });
      } else {
        console.error("Select call failed with status:", response.status);
      }
    } catch (err) {
      console.error("Select fetch error:", err);
    }
  };	  
	  
	for (let i = 1; i <= 1; i++) {
	  const sectionId = `#PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_${i}_SECTION`;
	  const headerId = `#PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_${i}_HEADER`;

	  if ($(sectionId).length && $(headerId).length) {
		
		const hiddenSections = [1];
		if (hiddenSections.includes(i)) {
		  $(sectionId).hide();
		} else {
		  $(sectionId).show();
		}

		$(headerId).off("click").on("click", function () {
		  $(sectionId).slideToggle();

		  const icon = $(this).find(".toggle-icon");
		  const current = icon.text().trim();

		  if (current === "v") {
			icon.text("^");
		  } else {
			icon.text("v");
		  }
		});
	  }
	}
	
	const searchInput = $('input[type="search"]');
 	const Temp_Search = App_Data["Object_Search"];
	if(Temp_Search!=""){
		searchInput.val(Temp_Search);
	}

	if(location.hash=="#Return"){
		const collectClientInfo = () => {
		return {
			userAgent: navigator.userAgent,
			language: navigator.language,
			platform: navigator.platform,
			screenResolution: `${screen.width}x${screen.height}`,
			colorDepth: screen.colorDepth,
			timezoneOffset: new Date().getTimezoneOffset(),
			timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
			cookieEnabled: navigator.cookieEnabled,
			javaEnabled: navigator.javaEnabled(),
			online: navigator.onLine,
			referrer: document.referrer,
			locationHref: window.location.href,
			screenOrientation: screen.orientation?.type || 'unknown'
		  };
		};
		
		const clientInfo = collectClientInfo();

		fetch('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/PREAUCT_TITLE_LIEN_PRECHECK/Select', {
		  method: 'POST',
		  headers: { 'Content-Type': 'application/json' },
		  body: JSON.stringify({ data:(App_Data&&App_Data.Data?App_Data.Data:{id:-1}) , clientInfo:clientInfo , stamp: Date.now() })
		}).catch(err => {
		  console.error("Error", err);
		});			
		navigate('/PREAUCT_Title_Lien_Precheck',{replace:true});
	}
	if(location.hash=="#New"){
		setApp_Data({ ...App_Data});
		navigate('/PREAUCT_Title_Lien_Precheck',{replace:true});
	}
	if(location.hash=="#Search"){
		setApp_Data({ ...App_Data});
		navigate('/PREAUCT_Title_Lien_Precheck_S',{replace:true});
	}
	if(location.hash=="#Update"){
		setApp_Data({ ...App_Data});
		navigate('/PREAUCT_Title_Lien_Precheck',{replace:true});
	}
	if(location.hash=="#FormPreview"){
		setApp_Data({ ...App_Data});
		navigate('/PREAUCT_Title_Lien_Precheck_P',{replace:true});
	}
	if(location.hash=="#SearchPreview"){
		setApp_Data({ ...App_Data});
		navigate('/PREAUCT_Title_Lien_Precheck_S_P',{replace:true});
	}
	if(location.hash=="#Print"){
		setApp_Data({ ...App_Data});
		navigate('/PREAUCT_Title_Lien_Precheck_P',{replace:true});
	}
	if(location.hash=="#Delete"){
		setApp_Data({ ...App_Data});
		navigate('/PREAUCT_Title_Lien_Precheck',{replace:true});
	}
	if(location.hash=="#Export"){
		setApp_Data({ ...App_Data});
		navigate('/PREAUCT_Title_Lien_Precheck',{replace:true});
	}
	if(location.hash=="#Import"){
		setApp_Data({ ...App_Data});
		navigate('/PREAUCT_Title_Lien_Precheck',{replace:true});
	}
	if(location.hash=="#Help"){
		setApp_Data({ ...App_Data});
		navigate('/PREAUCT_Title_Lien_Precheck',{replace:true});
	}
	if(location.hash=="#LogInLogOut"){
		setApp_Data({ ...App_Data});
		navigate('/PREAUCT_Title_Lien_Precheck',{replace:true});
	}

     	    window.DataTableScript('#Table9');

  })  

  const [PREAUCT_TITLE_LIEN_PRECHECK, setPREAUCT_TITLE_LIEN_PRECHECK] = React.useState(null);
  const [PREAUCT_TITLE_LIEN_PRECHECK_S, setPREAUCT_TITLE_LIEN_PRECHECK_S] = React.useState(null);

  var Ids = [];
  for(var Ele in PREAUCT_TITLE_LIEN_PRECHECK_S){
	  for(var Sec in PREAUCT_TITLE_LIEN_PRECHECK_S[Ele]){
			if(Sec == "id")
				Ids.push(PREAUCT_TITLE_LIEN_PRECHECK_S[Ele]["id"]);
			else if(Sec == "status")
				Ids.push(PREAUCT_TITLE_LIEN_PRECHECK_S[Ele]["status"]);
			else if(Array.isArray(PREAUCT_TITLE_LIEN_PRECHECK_S[Ele][Sec]))
				  for(var Row in PREAUCT_TITLE_LIEN_PRECHECK_S[Ele][Sec])
					for (var Id in Row) 
						Ids.push(Id);
			else
				for (var Id in PREAUCT_TITLE_LIEN_PRECHECK_S[Ele][Sec]) 
					Ids.push(Id);
	  }
  }
  
  const [isValid, setIsValid] = useState(Object.fromEntries(Ids.map(key => [key, true])));
   
   
  React.useEffect(() => {
    axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/PREAUCT_TITLE_LIEN_PRECHECK`).then((response) => {
      setPREAUCT_TITLE_LIEN_PRECHECK(response.data);
	  
		var Temp_Detail = [];
		Object.keys(response.data).map((key, index) => {
		  var Temp_Obj={};
		  var Temp_Val = JSON.parse(JSON.stringify(response.data[index]));
		  for(var Sec in Temp_Val){
		     if(Sec == "id")
						Temp_Obj["id"] = Temp_Val[Sec];
			 else if(Array.isArray(Temp_Val[Sec])){
					  for(var Row in Temp_Val[Sec])
						for (var Id in Temp_Val[Sec][Row]){ 
							if(Temp_Obj.hasOwnProperty(Id))
								Temp_Obj[Id] += "|||"+Temp_Val[Sec][Row][Id];
							else
								Temp_Obj[Id]=Temp_Val[Sec][Row][Id];
						}
			}else{
				for (var Id in Temp_Val[Sec]){ 
					Temp_Obj[Id] = Temp_Val[Sec][Id];
				}
			}
		  }
		  Temp_Detail.push(Temp_Obj);
	  })
	  //setALLFIELDS_S(JSON.parse(JSON.stringify(Temp_Detail)));	  

	setPREAUCT_TITLE_LIEN_PRECHECK_S(JSON.parse(JSON.stringify(Temp_Detail)));
	  
	  
	  
    });
	//$('#navbarNav1').show();
//$('#navbarNav6').show();

  }, []);

  if (!PREAUCT_TITLE_LIEN_PRECHECK_S) return <div>Loading...</div>;

 const handleLastDataPREAUCT_TITLE_LIEN_PRECHECK_S = async (data) => {
  };




  const handleAddPREAUCT_TITLE_LIEN_PRECHECK_S = async () => {
    try {
      await axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/PREAUCT_TITLE_LIEN_PRECHECK_S', JSON.parse(JSON.stringify(PREAUCT_TITLE_LIEN_PRECHECK_S)));

      const response = await axios.get('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/PREAUCT_TITLE_LIEN_PRECHECK_S');
      setPREAUCT_TITLE_LIEN_PRECHECK_S(response.data);
    } catch (error) {
      console.error('Error adding post:', error);
    }
  };
  

    
const PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_1_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_1_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_TITLE_LIEN_PRECHECK_S));
	Temp_Data["1"]["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_1_0"]=value;
	//handleAddPREAUCT_TITLE_LIEN_PRECHECK_S(Temp_Data,App_Data['PREAUCT_TITLE_LIEN_PRECHECK_S']);
	Form_Data_onChange("1","PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_1_0",value,Temp_Data);
 	//handleLastDataPREAUCT_TITLE_LIEN_PRECHECK_S(Temp_Data);
    setPREAUCT_TITLE_LIEN_PRECHECK_S(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_1_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_1_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_TITLE_LIEN_PRECHECK_S));
	Temp_Data["1"]["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_1_1"]=value;
	//handleAddPREAUCT_TITLE_LIEN_PRECHECK_S(Temp_Data,App_Data['PREAUCT_TITLE_LIEN_PRECHECK_S']);
	Form_Data_onChange("1","PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_1_1",value,Temp_Data);
 	//handleLastDataPREAUCT_TITLE_LIEN_PRECHECK_S(Temp_Data);
    setPREAUCT_TITLE_LIEN_PRECHECK_S(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_1_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_1_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_TITLE_LIEN_PRECHECK_S));
	Temp_Data["1"]["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_1_2"]=value;
	//handleAddPREAUCT_TITLE_LIEN_PRECHECK_S(Temp_Data,App_Data['PREAUCT_TITLE_LIEN_PRECHECK_S']);
	Form_Data_onChange("1","PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_1_2",value,Temp_Data);
 	//handleLastDataPREAUCT_TITLE_LIEN_PRECHECK_S(Temp_Data);
    setPREAUCT_TITLE_LIEN_PRECHECK_S(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_1_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_1_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_TITLE_LIEN_PRECHECK_S));
	Temp_Data["1"]["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_1_3"]=value;
	//handleAddPREAUCT_TITLE_LIEN_PRECHECK_S(Temp_Data,App_Data['PREAUCT_TITLE_LIEN_PRECHECK_S']);
	Form_Data_onChange("1","PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_1_3",value,Temp_Data);
 	//handleLastDataPREAUCT_TITLE_LIEN_PRECHECK_S(Temp_Data);
    setPREAUCT_TITLE_LIEN_PRECHECK_S(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_2_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_2_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_TITLE_LIEN_PRECHECK_S));
	Temp_Data["2"]["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_2_0"]=value;
	//handleAddPREAUCT_TITLE_LIEN_PRECHECK_S(Temp_Data,App_Data['PREAUCT_TITLE_LIEN_PRECHECK_S']);
	Form_Data_onChange("2","PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_2_0",value,Temp_Data);
 	//handleLastDataPREAUCT_TITLE_LIEN_PRECHECK_S(Temp_Data);
    setPREAUCT_TITLE_LIEN_PRECHECK_S(Temp_Data);
 }; 
  

const PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_2_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_2_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_TITLE_LIEN_PRECHECK));
	Temp_Data["2"]["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_2_1"]=value;
	Form_Data_onChange("2","PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_2_1",value,Temp_Data);
 	//handleLastDataPREAUCT_TITLE_LIEN_PRECHECK(Temp_Data);
    setPREAUCT_TITLE_LIEN_PRECHECK(Temp_Data);
	//handleAddPREAUCT_TITLE_LIEN_PRECHECK(Temp_Data,App_Data['PREAUCT_TITLE_LIEN_PRECHECK']);
  }; 
  

  
      
const PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_2_2_Change = (event) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_2_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_TITLE_LIEN_PRECHECK_S));
	Temp_Data["2"]["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_2_2"]=value ? true : false; // optionally just use boolean
	//handleAddPREAUCT_TITLE_LIEN_PRECHECK_S(Temp_Data,App_Data['PREAUCT_TITLE_LIEN_PRECHECK_S']);
	Form_Data_onChange("2","PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_2_2",value,Temp_Data);
 	//handleLastDataPREAUCT_TITLE_LIEN_PRECHECK_S(Temp_Data);
    setPREAUCT_TITLE_LIEN_PRECHECK_S(Temp_Data);
 }; 
  


    
const PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_2_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_2_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_TITLE_LIEN_PRECHECK_S));
	Temp_Data["2"]["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_2_3"]=value;
	//handleAddPREAUCT_TITLE_LIEN_PRECHECK_S(Temp_Data,App_Data['PREAUCT_TITLE_LIEN_PRECHECK_S']);
	Form_Data_onChange("2","PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_2_3",value,Temp_Data);
 	//handleLastDataPREAUCT_TITLE_LIEN_PRECHECK_S(Temp_Data);
    setPREAUCT_TITLE_LIEN_PRECHECK_S(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_2_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_2_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_TITLE_LIEN_PRECHECK_S));
	Temp_Data["2"]["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_2_4"]=value;
	//handleAddPREAUCT_TITLE_LIEN_PRECHECK_S(Temp_Data,App_Data['PREAUCT_TITLE_LIEN_PRECHECK_S']);
	Form_Data_onChange("2","PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_2_4",value,Temp_Data);
 	//handleLastDataPREAUCT_TITLE_LIEN_PRECHECK_S(Temp_Data);
    setPREAUCT_TITLE_LIEN_PRECHECK_S(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_3_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_3_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_TITLE_LIEN_PRECHECK_S));
	Temp_Data["3"]["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_3_0"]=value;
	//handleAddPREAUCT_TITLE_LIEN_PRECHECK_S(Temp_Data,App_Data['PREAUCT_TITLE_LIEN_PRECHECK_S']);
	Form_Data_onChange("3","PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_3_0",value,Temp_Data);
 	//handleLastDataPREAUCT_TITLE_LIEN_PRECHECK_S(Temp_Data);
    setPREAUCT_TITLE_LIEN_PRECHECK_S(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_3_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_3_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_TITLE_LIEN_PRECHECK_S));
	Temp_Data["3"]["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_3_1"]=value;
	//handleAddPREAUCT_TITLE_LIEN_PRECHECK_S(Temp_Data,App_Data['PREAUCT_TITLE_LIEN_PRECHECK_S']);
	Form_Data_onChange("3","PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_3_1",value,Temp_Data);
 	//handleLastDataPREAUCT_TITLE_LIEN_PRECHECK_S(Temp_Data);
    setPREAUCT_TITLE_LIEN_PRECHECK_S(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_4_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_4_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_TITLE_LIEN_PRECHECK_S));
	Temp_Data["4"]["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_4_0"]=value;
	//handleAddPREAUCT_TITLE_LIEN_PRECHECK_S(Temp_Data,App_Data['PREAUCT_TITLE_LIEN_PRECHECK_S']);
	Form_Data_onChange("4","PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_4_0",value,Temp_Data);
 	//handleLastDataPREAUCT_TITLE_LIEN_PRECHECK_S(Temp_Data);
    setPREAUCT_TITLE_LIEN_PRECHECK_S(Temp_Data);
 }; 
  

const PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_4_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_4_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_TITLE_LIEN_PRECHECK));
	Temp_Data["4"]["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_4_1"]=value;
	Form_Data_onChange("4","PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_4_1",value,Temp_Data);
 	//handleLastDataPREAUCT_TITLE_LIEN_PRECHECK(Temp_Data);
    setPREAUCT_TITLE_LIEN_PRECHECK(Temp_Data);
	//handleAddPREAUCT_TITLE_LIEN_PRECHECK(Temp_Data,App_Data['PREAUCT_TITLE_LIEN_PRECHECK']);
  }; 
  

    
const PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_5_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_5_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_TITLE_LIEN_PRECHECK_S));
	Temp_Data["5"]["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_5_0"]=value;
	//handleAddPREAUCT_TITLE_LIEN_PRECHECK_S(Temp_Data,App_Data['PREAUCT_TITLE_LIEN_PRECHECK_S']);
	Form_Data_onChange("5","PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_5_0",value,Temp_Data);
 	//handleLastDataPREAUCT_TITLE_LIEN_PRECHECK_S(Temp_Data);
    setPREAUCT_TITLE_LIEN_PRECHECK_S(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_5_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_5_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_TITLE_LIEN_PRECHECK_S));
	Temp_Data["5"]["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_5_1"]=value;
	//handleAddPREAUCT_TITLE_LIEN_PRECHECK_S(Temp_Data,App_Data['PREAUCT_TITLE_LIEN_PRECHECK_S']);
	Form_Data_onChange("5","PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_5_1",value,Temp_Data);
 	//handleLastDataPREAUCT_TITLE_LIEN_PRECHECK_S(Temp_Data);
    setPREAUCT_TITLE_LIEN_PRECHECK_S(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_5_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_5_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_TITLE_LIEN_PRECHECK_S));
	Temp_Data["5"]["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_5_2"]=value;
	//handleAddPREAUCT_TITLE_LIEN_PRECHECK_S(Temp_Data,App_Data['PREAUCT_TITLE_LIEN_PRECHECK_S']);
	Form_Data_onChange("5","PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_5_2",value,Temp_Data);
 	//handleLastDataPREAUCT_TITLE_LIEN_PRECHECK_S(Temp_Data);
    setPREAUCT_TITLE_LIEN_PRECHECK_S(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_5_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_5_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_TITLE_LIEN_PRECHECK_S));
	Temp_Data["5"]["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_5_3"]=value;
	//handleAddPREAUCT_TITLE_LIEN_PRECHECK_S(Temp_Data,App_Data['PREAUCT_TITLE_LIEN_PRECHECK_S']);
	Form_Data_onChange("5","PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_5_3",value,Temp_Data);
 	//handleLastDataPREAUCT_TITLE_LIEN_PRECHECK_S(Temp_Data);
    setPREAUCT_TITLE_LIEN_PRECHECK_S(Temp_Data);
 }; 
  

const PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_5_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_5_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_TITLE_LIEN_PRECHECK));
	Temp_Data["5"]["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_5_4"]=value;
	Form_Data_onChange("5","PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_5_4",value,Temp_Data);
 	//handleLastDataPREAUCT_TITLE_LIEN_PRECHECK(Temp_Data);
    setPREAUCT_TITLE_LIEN_PRECHECK(Temp_Data);
	//handleAddPREAUCT_TITLE_LIEN_PRECHECK(Temp_Data,App_Data['PREAUCT_TITLE_LIEN_PRECHECK']);
  }; 
  

    
const PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_5_5_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_5_5"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_TITLE_LIEN_PRECHECK_S));
	Temp_Data["5"]["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_5_5"]=value;
	//handleAddPREAUCT_TITLE_LIEN_PRECHECK_S(Temp_Data,App_Data['PREAUCT_TITLE_LIEN_PRECHECK_S']);
	Form_Data_onChange("5","PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_5_5",value,Temp_Data);
 	//handleLastDataPREAUCT_TITLE_LIEN_PRECHECK_S(Temp_Data);
    setPREAUCT_TITLE_LIEN_PRECHECK_S(Temp_Data);
 }; 
  

const PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_9_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_9_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_TITLE_LIEN_PRECHECK));
	Temp_Data["9"]["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_9_0"]=value;
	Form_Data_onChange("9","PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_9_0",value,Temp_Data);
 	//handleLastDataPREAUCT_TITLE_LIEN_PRECHECK(Temp_Data);
    setPREAUCT_TITLE_LIEN_PRECHECK(Temp_Data);
	//handleAddPREAUCT_TITLE_LIEN_PRECHECK(Temp_Data,App_Data['PREAUCT_TITLE_LIEN_PRECHECK']);
  }; 
  

    
const PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_9_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_9_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_TITLE_LIEN_PRECHECK_S));
	Temp_Data["9"]["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_9_1"]=value;
	//handleAddPREAUCT_TITLE_LIEN_PRECHECK_S(Temp_Data,App_Data['PREAUCT_TITLE_LIEN_PRECHECK_S']);
	Form_Data_onChange("9","PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_9_1",value,Temp_Data);
 	//handleLastDataPREAUCT_TITLE_LIEN_PRECHECK_S(Temp_Data);
    setPREAUCT_TITLE_LIEN_PRECHECK_S(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_9_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_9_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_TITLE_LIEN_PRECHECK_S));
	Temp_Data["9"]["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_9_2"]=value;
	//handleAddPREAUCT_TITLE_LIEN_PRECHECK_S(Temp_Data,App_Data['PREAUCT_TITLE_LIEN_PRECHECK_S']);
	Form_Data_onChange("9","PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_9_2",value,Temp_Data);
 	//handleLastDataPREAUCT_TITLE_LIEN_PRECHECK_S(Temp_Data);
    setPREAUCT_TITLE_LIEN_PRECHECK_S(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_9_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_9_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_TITLE_LIEN_PRECHECK_S));
	Temp_Data["9"]["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_9_3"]=value;
	//handleAddPREAUCT_TITLE_LIEN_PRECHECK_S(Temp_Data,App_Data['PREAUCT_TITLE_LIEN_PRECHECK_S']);
	Form_Data_onChange("9","PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_9_3",value,Temp_Data);
 	//handleLastDataPREAUCT_TITLE_LIEN_PRECHECK_S(Temp_Data);
    setPREAUCT_TITLE_LIEN_PRECHECK_S(Temp_Data);
 }; 
  
    
const PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_9_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_9_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(PREAUCT_TITLE_LIEN_PRECHECK_S));
	Temp_Data["9"]["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_9_4"]=value;
	//handleAddPREAUCT_TITLE_LIEN_PRECHECK_S(Temp_Data,App_Data['PREAUCT_TITLE_LIEN_PRECHECK_S']);
	Form_Data_onChange("9","PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_9_4",value,Temp_Data);
 	//handleLastDataPREAUCT_TITLE_LIEN_PRECHECK_S(Temp_Data);
    setPREAUCT_TITLE_LIEN_PRECHECK_S(Temp_Data);
 }; 
  


 
const Form_Data_onChange = (Sec,ID) => {

};


 
   const handleSingleClick = (event,ID) => {
	$(event.currentTarget).siblings().removeClass('selected');
    event.currentTarget.classList.toggle('selected');
   };


   const handleDoubleClick = (event,ID) => {
    const selectedRowId = event.currentTarget.id.replace("TR","");
	selectedData = PREAUCT_TITLE_LIEN_PRECHECK_S.find(e => e.id == selectedRowId);
    //App_Data.Return_Data=selectedRowId;
    App_Data.Object_Return=selectedRowId;
    //console.log(event.currentTarget.querySelector('td').textContent);
    App_Data.Object_Text=selectedRowId+";"+event.currentTarget.querySelector('td').textContent;
    App_Data.Object_Id=selectedRowId;
	App_Data.Data=selectedData;
	setApp_Data({ ...App_Data})
    window.location.hash = 'Return';
   };
 
  return <>
			<nav className="navbar navbar-expand-lg navbar-light bg-light">
			 <div style={{ padding: '10px 20px', fontSize: '1.5rem', fontWeight: 'bold' }}>
			  {t('Select Pre-Auction Title and Lien Precheck')}
			  <hr style={{ marginTop: '8px', borderTop: '2px solid #007bff', width: '100%' }} />
			</div>
			 <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
				aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
			 <span className="navbar-toggler-icon"></span>
			 </button>
			 <div className="collapse navbar-collapse" id="navbarNav">
				<ul className="navbar-nav">
				   <li className="nav-item">
					  <a id="navbarNav1" className="nav-link" href="#Return">{t(`Return`)}</a>
				   </li>
				</ul>
			 </div>
		  </nav>		 
         {/* Search Fields*/}
         <div className="container-fluid mt-5">
            <h2  id="PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_1_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Advanced Search`)} <span className="toggle-icon">v</span></h2>
            <div  id="PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_1_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`PREAUCT Title Lien Precheck ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_1_0" type="text" className="form-control" placeholder="PREAUCT Title Lien Precheck ID"  
						onChange={PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_1_0_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_1_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter PREAUCT Title Lien Precheck ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`PREAUCT Auction Opportunity ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_1_1" type="text" className="form-control" placeholder="PREAUCT Auction Opportunity ID"  
						onChange={PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_1_1_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_1_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter PREAUCT Auction Opportunity ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '80ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Parcel Number`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_1_2" type="text" className="form-control" placeholder="Parcel Number"  
						onChange={PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_1_2_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_1_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '80ch' }}>
						 {t(`Enter Parcel Number`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '160ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Preliminary Title Source`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_1_3" type="text" className="form-control" placeholder="Preliminary Title Source"  
						onChange={PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_1_3_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_1_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '160ch' }}>
						 {t(`Enter Preliminary Title Source`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '180ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Owner Of Record`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_2_0" type="text" className="form-control" placeholder="Owner Of Record"  
						onChange={PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_2_0_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_2_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '180ch' }}>
						 {t(`Enter Owner Of Record`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Deed Type`)}
					 </div>
                     <div className="card-body" >
                        <select id="PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_2_1"   onChange={PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_2_1_Change} className="form-control" name="Deed Type"  >
						  <option value="Warranty Deed">Warranty Deed</option>
						  <option value="Special Warranty Deed">Special Warranty Deed</option>
						  <option value="Quitclaim Deed">Quitclaim Deed</option>
						  <option value="Trustee Deed">Trustee Deed</option>
						  <option value="Sheriff Deed">Sheriff Deed</option>
						  <option value="Tax Deed">Tax Deed</option>
						  <option value="Other">Other</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Deed Type
				     </div>
                  </div>
               </div>
               {/* Check Box */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3"  style={{ border: 'none'}}>
					 <label htmlFor="PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_2_2" style={{ cursor: 'pointer', userSelect: 'none' }}>
					  {t(`Lien Search Completed`)} <input id="PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_2_2" type="checkbox" style={{ marginLeft: '5px' }}  onChange={PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_2_2_Change} 
					  checked={PREAUCT_TITLE_LIEN_PRECHECK_S?.["2"]?.["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_2_2"] === "true" || PREAUCT_TITLE_LIEN_PRECHECK_S?.["2"]?.["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_2_2"] === true} />
					</label>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '50ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Known Lien Count`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_2_3" type="text" className="form-control" placeholder="Known Lien Count"  
						onChange={PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_2_3_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_2_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '50ch' }}>
						 {t(`Enter Known Lien Count`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '90ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Known Lien Total USD`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_2_4" type="text" className="form-control" placeholder="Known Lien Total USD"  
						onChange={PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_2_4_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_2_4"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '90ch' }}>
						 {t(`Enter Known Lien Total USD`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '90ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Tax Delinquent Amount USD`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_3_0" type="text" className="form-control" placeholder="Tax Delinquent Amount USD"  
						onChange={PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_3_0_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_3_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '90ch' }}>
						 {t(`Enter Tax Delinquent Amount USD`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '3000ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Title Exception Notes`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_3_1" type="text" className="form-control" placeholder="Title Exception Notes"  
						onChange={PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_3_1_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_3_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '3000ch' }}>
						 {t(`Enter Title Exception Notes`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '255ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Precheck Report Link`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_4_0" type="text" className="form-control" placeholder="Precheck Report Link"  
						onChange={PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_4_0_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_4_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '255ch' }}>
						 {t(`Enter Precheck Report Link`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Precheck Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_4_1"   onChange={PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_4_1_Change} className="form-control" name="Precheck Status"  >
						  <option value="Not Started">Not Started</option>
						  <option value="Clear">Clear</option>
						  <option value="Issue Found">Issue Found</option>
						  <option value="Needs Legal Review">Needs Legal Review</option>
						  <option value="Rejected">Rejected</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Precheck Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Submitted By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_5_0" type="text" className="form-control" placeholder="Submitted By"  
						onChange={PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_5_0_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_5_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Submitted By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Submitted At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_5_1" type="text" className="form-control" placeholder="Submitted At"  
						onChange={PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_5_1_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_5_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Submitted At`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Reviewed By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_5_2" type="text" className="form-control" placeholder="Reviewed By"  
						onChange={PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_5_2_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_5_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Reviewed By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Reviewed At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_5_3" type="text" className="form-control" placeholder="Reviewed At"  
						onChange={PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_5_3_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_5_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Reviewed At`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Approval Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_5_4"   onChange={PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_5_4_Change} className="form-control" name="Approval Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Submitted">Submitted</option>
						  <option value="Under Review">Under Review</option>
						  <option value="Revision Requested">Revision Requested</option>
						  <option value="Approved">Approved</option>
						  <option value="Rejected">Rejected</option>
						  <option value="Withdrawn">Withdrawn</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Approval Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '3000ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Approval Notes`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_5_5" type="text" className="form-control" placeholder="Approval Notes"  
						onChange={PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_5_5_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_5_5"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '3000ch' }}>
						 {t(`Enter Approval Notes`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Record Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_9_0"   onChange={PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_9_0_Change} className="form-control" name="Record Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Active">Active</option>
						  <option value="Inactive">Inactive</option>
						  <option value="Archived">Archived</option>
						  <option value="Deleted">Deleted</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Record Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_9_1" type="text" className="form-control" placeholder="Created By"  
						onChange={PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_9_1_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_9_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Created By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_9_2" type="text" className="form-control" placeholder="Created At"  
						onChange={PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_9_2_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_9_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Created At`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_9_3" type="text" className="form-control" placeholder="Updated By"  
						onChange={PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_9_3_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_9_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Updated By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_9_4" type="text" className="form-control" placeholder="Updated At"  
						onChange={PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_9_4_Change} style={{ ...inputFontStyle, borderColor: isValid["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_9_4"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Updated At`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
		 {/* Query Result*/}
         <div className="container-fluid mt-5">
            <h2 style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Query Result`)}</h2>
            <div className="row">
			                 {/* Table with Bootstrap Cards and DataTables */}
			   <button onClick={() => handleAddRow('9')}  style={{ display: 'none' }} className="btn btn-primary">
				  {t('Add Row')}
			   </button>
               <table id="Table9" className="table">
                  <thead>
                     <tr>
					                         <th>{t(`PREAUCT Title Lien Precheck ID`)}</th>
                        <th>{t(`PREAUCT Auction Opportunity ID`)}</th>
                        <th>{t(`Parcel Number`)}</th>
                        <th>{t(`Preliminary Title Source`)}</th>
                        <th>{t(`Owner Of Record`)}</th>
                        <th>{t(`Deed Type`)}</th>
                        <th>{t(`Lien Search Completed`)}</th>
                        <th>{t(`Known Lien Count`)}</th>
                        <th>{t(`Known Lien Total USD`)}</th>
                        <th>{t(`Tax Delinquent Amount USD`)}</th>
                        <th>{t(`Title Exception Notes`)}</th>
                        <th>{t(`Precheck Report Link`)}</th>
                        <th>{t(`Precheck Status`)}</th>
                        <th>{t(`Submitted By`)}</th>
                        <th>{t(`Submitted At`)}</th>
                        <th>{t(`Reviewed By`)}</th>
                        <th>{t(`Reviewed At`)}</th>
                        <th>{t(`Approval Status`)}</th>
                        <th>{t(`Approval Notes`)}</th>
                        <th>{t(`Record Status`)}</th>
                        <th>{t(`Created By`)}</th>
                        <th>{t(`Created At`)}</th>
                        <th>{t(`Updated By`)}</th>
                        <th>{t(`Updated At`)}</th>

                     </tr>
                  </thead>
                  <tbody>
				    {PREAUCT_TITLE_LIEN_PRECHECK_S.map((e, i) => {
                     return<tr  onClick={((e) => handleSingleClick(e,"TR"+e[`id`]))}  onDoubleClick={((e) => handleDoubleClick(e,"TR"+e[`id`]))} key={(e.id || i)} id={"TR"+(e.id || i)}>
						<td>{e["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_1_0"]} </td>
						<td>{e["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_1_1"]} </td>
						<td>{e["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_1_2"]} </td>
						<td>{e["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_1_3"]} </td>
						<td>{e["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_2_0"]} </td>
						<td>{e["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_2_1"]} </td>
						<td>{e["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_2_2"]} </td>
						<td>{e["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_2_3"]} </td>
						<td>{e["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_2_4"]} </td>
						<td>{e["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_3_0"]} </td>
						<td>{e["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_3_1"]} </td>
						<td>{e["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_4_0"]} </td>
						<td>{e["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_4_1"]} </td>
						<td>{e["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_5_0"]} </td>
						<td>{e["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_5_1"]} </td>
						<td>{e["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_5_2"]} </td>
						<td>{e["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_5_3"]} </td>
						<td>{e["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_5_4"]} </td>
						<td>{e["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_5_5"]} </td>
						<td>{e["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_9_0"]} </td>
						<td>{e["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_9_1"]} </td>
						<td>{e["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_9_2"]} </td>
						<td>{e["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_9_3"]} </td>
						<td>{e["PRE_AUCTION_POOL_02_DUE_DILIGENCE_TITLE_RISK_MAX_BID_PREAUCT_TITLE_LIEN_PRECHECK_9_4"]} </td>

                     </tr>	
					})}
                  </tbody>
               </table>
							   
            </div>
         </div>
  </>;
};

export default PREAUCT_Title_Lien_Precheck_S;  